import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, from, map } from 'rxjs';
import { HttpUtils } from '../utils/httpUtils';

@Injectable({
  providedIn: 'root'
})
export class CountingEfficiencyService {

  protected readonly url = environment.particlesUrl + '/countingEfficiency/';

  constructor(private http: HttpClient) {
  }

  findAll(): Observable<any> {
        return this.http.get(this.url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
